/**
 * Liberações de compra (MedicationDispense) do paciente para um dispensador.
 * @module usePatientStorePurchaseReleases
 */

import { useMemo } from "react";

import { useLocalPurchaseReleases } from "../../purchase-release/useLocalPurchaseReleases";
import { buildProductReleaseLimitsByWooId } from "../../purchase-release/purchaseReleaseLimits";
import type { WooStoreConfig } from "../types";

export function usePatientStorePurchaseReleases(
  patientReference: string | undefined,
  store: WooStoreConfig | null,
) {
  const organizationId = store?.institutionId?.trim() ?? "";

  const { batches, loading, error, refetch } = useLocalPurchaseReleases(
    patientReference,
    {
      organizationId,
      storeName: store?.name ?? "",
      enabled: Boolean(patientReference && organizationId && store),
    },
  );

  const releaseLimits = useMemo(() => {
    const dispenses = batches.flatMap((batch) => batch.dispenses);
    return buildProductReleaseLimitsByWooId(dispenses);
  }, [batches]);

  const getReleaseLimit = useMemo(
    () => (productId: number) => releaseLimits.get(productId)?.quantity ?? 0,
    [releaseLimits],
  );

  return {
    releaseLimits,
    getReleaseLimit,
    hasAnyRelease: releaseLimits.size > 0,
    loading,
    error,
    refetch,
  };
}
